<template>
  <div class="white-container equity-page">
    <el-tabs v-model="activeName" :before-leave="beforeLeave" class="equity-tabs">
      <el-tab-pane label="新品优先权" name="one" />
      <el-tab-pane label="限量包装券" name="two" />
      <el-tab-pane label="免费洗鞋券" name="three" />
      <el-tab-pane label="运动体验券" name="four" />
      <el-tab-pane label="活动专属优惠" name="five" />
      <el-tab-pane label="促销优先权" name="six" />
      <el-tab-pane label="品牌活动邀请" name="seven" />
      <el-tab-pane label="周年纪念礼" name="eight">
        <el-form ref="form" class="my-form" :model="form" :rules="rules" label-width="120px" size="small">
          <el-form-item label="权益主标题" prop="titles">
            <div v-if="isEdit" class="mainTitleWrap flex">
              <template v-for="(mainTitle,titleN) in form.titles">
                <el-input :key="titleN+'mainTitle'" v-model="form.titles[titleN]" class="common-input" :placeholder="titleN === 0 ? '请输入第一行主标题文案' : '请输入第二行主标题文案' " />
              </template>
            </div>
            <div v-else class="lh-20" style="padding-top: 5px;">
              <div v-for="(mainTitle,titleN) in form.titles" :key="titleN+'mainTitle'">{{ mainTitle }}</div>
            </div>

          </el-form-item>
          <el-form-item label="副标题" prop="subtitles">
            <div v-if="isEdit" class="subTitleWrap flex">
              <template v-for="(subTitle,titleN) in form.subtitles">
                <el-input :key="titleN+'subTitle'" v-model="form.subtitles[titleN]" class="common-input" :placeholder="titleN === 0 ? '请输入第一行副标题文案' : '请输入第二行副标题文案'" />
              </template>
            </div>
            <div v-else class="lh-20" style="padding-top: 5px;">
              <div v-for="(subTitle,titleN) in form.subtitles" :key="titleN+'subTitle'">{{ subTitle }}</div>
            </div>
          </el-form-item>
          <el-form-item label="卡片背景图" prop="imageUrl" class="image-config">
            <div class="flex uploadImg-cont">
              <UploadImage v-if="isEdit" :url="form.imageUrl" size-tips="960px*660px" :save-path="savePath" @upload="uploader" @triggerReg="handleCheckReg" />
              <img v-else class="read-img" :src="form.imageUrl" alt="">
            </div>
          </el-form-item>
          <div class="product-wrap">
            <div class="gap" />
            <div class="title">礼品配置</div>
            <el-form-item label="礼品名称" prop="productName" style="width: 744px">
              <el-input v-if="isEdit" v-model="form.productName" placeholder="请输入礼品名称" />
              <div v-else>{{ form.productName }}</div>
            </el-form-item>
            <el-form-item label="礼品描述" prop="productDescription" style="width: 744px">
              <el-input v-if="isEdit" v-model="form.productDescription" :rows="4" type="textarea" placeholder="请输入礼品描述" />
              <div v-else>{{ form.productDescription }}</div>
            </el-form-item>
            <el-form-item label="礼品图片" prop="productImages" class="image-config">
              <div v-if="isEdit" class="flex uproductImg-cont">
                <ProductImage v-if="form.productImages.length < 9" url="" size-tips="1125px*1125px" :save-path="savePath" @upload="productImgUp" @triggerReg="checkProductImage" />
                <div v-for="(item,index) in form.productImages" :key="item+index" class="img-box">
                  <img :src="item" alt="" style="width: 150px; height: 150px;">
                  <svg-icon class="close" icon-class="carbon_close" @click="removeProductImg(index)" />
                </div>
              </div>
              <div v-else class="flex">
                <img v-for="(item,index) in form.productImages" :key="item+index" class="product-img" :src="item" alt="">
              </div>
            </el-form-item>
            <el-form-item class="opetare-box flex">
              <div class="flex btns">
                <template v-if=" isEdit">
                  <el-button type="info" @click="cancel">取消</el-button>
                  <el-button type="primary" @click="submit">保存</el-button>
                </template>
                <template v-else>
                  <el-button type="info" @click="edit">编辑权益</el-button>
                  <el-button type="primary" @click="offShelf">下架此项权益</el-button>
                </template>

              </div>
            </el-form-item>
          </div>

        </el-form>
      </el-tab-pane>

    </el-tabs>
    <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="dialogSuccess" />
  </div>
</template>
<script>
import { BenefitsRoutes, AnniversaryCeremony } from '@/model/Benefits';

import UploadImage from '@/components/UploadImage';
import Dialog from '@/components/Dialog';
import ProductImage from './ProductImage.vue';
export default {
  components: { UploadImage, ProductImage, Dialog },
  data() {
    return {
      savePath: "member/anniversaryCeremony/",
      BenefitsRoutes,
      activeName: 'eight',
      form: new AnniversaryCeremony(),
      id: undefined,
      rules: {
        titles: [
          {
            required: true, validator: (rule, value, callback) => {
              if (!Array.isArray(value)) {
                callback(new Error('请输入权益主标题'));
              }
              const bool = value.some(item => item !== '');
              if (!bool) {
                callback(new Error('请输入权益主标题'));
              }
              callback();
            }, trigger: ['blur', 'change'],
          },
        ],
        subtitles: [
          {
            required: true, validator: (rule, value, callback) => {
              if (!Array.isArray(value)) {
                callback(new Error('请输入副标题'));
              }
              const bool = value.some(item => item !== '');
              if (!bool) {
                callback(new Error('请输入副标题'));
              }
              callback();
            }, trigger: ['blur', 'change'],
          },
        ],

        imageUrl: [
          { required: true, message: '请上传卡片背景图', trigger: 'blur' },
        ],
        productName: [
          { required: true, message: '请输入礼品名称', trigger: 'blur' },
        ],
        productDescription: [
          { required: true, message: '请输入礼品描述', trigger: 'blur' },
        ],
        productImages: [
          {
            required: true, validator: (rule, value, callback) => {
              if (!value.length) {
                callback(new Error('请上传礼品图片'));
              }
              callback();
            }, trigger: ['blur', 'change'],
          },
        ],
      },
      isEdit: true,
      formDialogShow: false,
      information: {},
    };
  },
  created() {
    this.fetchData();
  },

  methods: {
    beforeLeave(activeName, oldActiveName) {
      this.$router.push({ path: this.BenefitsRoutes[activeName] || this.BenefitsRoutes['one'] });
    },
    fetchData() {
      this.$Api.benefits.query({ type: 7 }).then(res => {
        if (res?.anniversaryGift) {
          this.form = new AnniversaryCeremony(res.anniversaryGift);
          if (this.form.id) {
            this.isEdit = false;
          }
          if (res.anniversaryGift?.adminStatus === 2 || res.anniversaryGift?.adminStatus === 3) {
            this.isEdit = true;
          }
        }
      });
    },
    uploader(file) {
      this.form.imageUrl = file;
    },
    handleCheckReg() {
      this.$refs.form.validateField("imageUrl");
    },
    productImgUp(file) {
      this.form.productImages.unshift(file);
    },
    checkProductImage() {
      this.$refs.form.validateField("productImages");
    },
    removeProductImg(i) {
      this.form.productImages.splice(i, 1);
    },
    cancel() {
      this.isEdit = false;
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          const str = this.form.id ? '编辑成功' : '新增成功';
          const api = this.form.id ? this.$Api.benefits.update : this.$Api.benefits.add;
          const obj = { type: 7, anniversaryGift: this.form };
          delete obj.anniversaryGift.adminStatus;
          api(obj).then(res => {
            this.$message.success(str);
            this.fetchData();
            this.cancel();
          });
        }
      });
    },
    edit() {
      if (this.form.adminStatus === 0 || this.form.adminStatus === 1) {
        this.formDialogShow = true;
        this.information = {
          operation: 'edit',
          icon: 'warn',
          subTitle: '权益已对外发布，领取期间内不能编辑，如有紧急问题，请使用下架此项权益',
          hideCancel: true,
        };
        return;
      }
      this.isEdit = true;
    },
    offShelf() {
      this.formDialogShow = true;
      this.information = {
        operation: 'offShelf',
        icon: 'warn',
        subTitle: '如已对外发布，请谨慎操作，确定下架此项权益吗？',
      };
    },
    postOffline() {
      this.$Api.benefits.offShelf({ type: 7, id: this.form.id }).then(res => {
        this.$message.success('下架成功');
        this.fetchData();
      });
    },
    dialogSuccess(operation) {
      if (operation === 'offShelf') {
        this.postOffline();
      }
    },
  },
};

</script>
<style lang="less" scoped>
.equity-page {
  position: relative;

  display: flex;
  flex-direction: column;

  min-height: calc(100vh - 178px);
  .lh-20 {
    line-height: 20px;
  }
  .common-input {
    width: 360px;
    margin-right: 30px;
  }
  :deep(.equity-tabs) {
    flex: 1;

    height: 100%;
    .el-tabs__header {
      margin: 0 0 30px;
    }
    .el-tabs__content {
      overflow-x: unset !important;
    }
    .day-input {
      width: 86px;
      margin: 0px 5px;
      .el-input__inner {
        text-align: center;
      }
    }
    .tips {
      flex-wrap: nowrap;

      margin-left: 5px;
    }
    .read-img {
      width: 210px;
      height: 150px;

      border-radius: 16px;
    }
    .product-wrap {
      .gap {
        width: calc(100% + 60px);
        height: 30px;
        margin-right: -30px;
        margin-bottom: 30px;
        margin-left: -30px;

        background: #f7f7f7;
      }
      .title {
        margin-bottom: 30px;

        color: #494949;

        font-size: 16px;
        font-weight: 500;
      }
      .uproductImg-cont {
        flex-wrap: wrap;
        .img-box {
          position: relative;

          display: flex;

          margin-right: 10px;
          margin-bottom: 10px;
          .close {
            position: absolute;
            z-index: 10;
            top: 0;
            right: 0;

            cursor: pointer;

            font-size: 32px;
          }
        }
      }
      .product-img {
        width: 150px;
        height: 150px;
        margin-right: 10px;
        margin-bottom: 10px;

        border: 1px dashed #e3e3e5;
        border-radius: 4px;
      }
    }
    .opetare-box {
      .el-form-item__content {
        width: 100%;
        .btns {
          justify-content: center;
        }
      }
    }
  }
}
</style>
